const mergeFooterState = (rootStore, props) => {
    if (rootStore.propStateStore.isEmbedded) {
        return;
    }
    mergePropsState(rootStore, props);
    mergeLanguageState(rootStore, props);
    mergeTranslationsState(rootStore, props);
    mergeMenuItemsState(rootStore, props);
};
const mergePropsState = (rootStore, props) => {
    if (props.isSSR && props.isSSR !== rootStore.propStateStore.isSsr) {
        rootStore.propStateStore.setIsSsr(props.isSSR);
    }
    if (props.isEmbedded && props.isEmbedded !== rootStore.propStateStore.isEmbedded) {
        rootStore.propStateStore.setIsEmbedded(props.isEmbedded);
    }
};
const mergeLanguageState = (rootStore, props) => {
    if (props.lang && props.lang !== rootStore.environmentStore.lang) {
        rootStore.environmentStore.setLang(props.lang);
    }
};
const mergeTranslationsState = (rootStore, props) => {
    if (props.translations && rootStore.translationsStore.translations !== props.translations) {
        rootStore.translationsStore.setTranslations(true, props.translations);
    }
};
const mergeMenuItemsState = (rootStore, props) => {
    if (props.columns && rootStore.footerColumnStore.columns !== props.columns) {
        rootStore.footerColumnStore.setFooterState(props.columns, true);
    }
    if (!props.columns) {
        rootStore.footerColumnStore.setProvided(false);
    }
};
export default mergeFooterState;
//# sourceMappingURL=FooterStateMergeUtil.js.map